import { timestampToDate } from '../../../utils/DateUtil';

const createProfileObj = (date, region, country, username, firstName, lastName, email, ageGroup, gender) => {
  return {
    signUpDate: date,
    region: region,
    country: country,
    username: username,
    firstName: firstName,
    lastName: lastName,
    email: email,
    ageGroup: ageGroup,
    gender: gender,
  };
};

export const getAge = (timestamp) => {
  let date = timestampToDate(timestamp);
  let [birthDay, birthMonth, birthYear] = date.split('/');

  let currentDate = new Date();
  let currentMonth = currentDate.getMonth();
  let currentDay = currentDate.getDate();

  let age = currentDate.getFullYear() - birthYear;

  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
    --age;
  }

  return age;
};

export const getAgeGroup = (age) => {
  if (14 <= age) {
    if (age <= 20) {
      return '14-20';
    } else if (age <= 30) {
      return '21-30';
    } else if (age <= 40) {
      return '31-40';
    } else if (age <= 50) {
      return '41-50';
    } else if (age <= 64) {
      return '51-64';
    } else {
      return '65+';
    }
  } else {
    return 'Under 14';
  }
};

export const generateProfileArray = (data) => {
  let temp = [];

  for (const profile of data) {
    let age = getAge(profile.birthDate);
    let ageGroup = getAgeGroup(age);
    let signupDate = timestampToDate(profile.createdAt);
    temp.push(createProfileObj(signupDate, profile.stateCode, profile.countryCode, profile.userName, profile.name, profile.lastName, profile.email, ageGroup, profile.gender));
  }

  return temp;
};

export const compareByStateCode = (firstObject, secondObject) => {
  if (firstObject.region < secondObject.region) {
    return -1;
  }

  if (firstObject.region > secondObject.region) {
    return 1;
  }

  return 0;
};

export const sortByState = (array) => {
  return array.sort(compareByStateCode);
};

export const downloadFile = (url, name) => {
  let aTag = document.createElement('a');
  aTag.href = url;
  aTag.download = name;
  aTag.click();

  window.URL.revokeObjectURL(url);
};

export const serialFileToArrayBuffer = (file) => {
  let buffer = new ArrayBuffer(file.length);

  let view = new Uint8Array(buffer);

  // manipulate buffer
  for (let i = 0; i < file.length; i++) {
    view[i] = file.charCodeAt(i);
    view[i] &= 0xff;
  }

  return buffer;
};

export const getArraybyRegion = (array, region) => {
  let filteredArray = array.filter((object) => object.region === region);
  return filteredArray;
};
